
export default function SocialMedia() {
  return (
    <section className="py-20 bg-[#FAF8F5]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <p className="text-sm font-semibold tracking-widest text-[#E8744F] uppercase mb-4">
          Stay Connected
        </p>
        <h2 className="text-4xl font-bold text-gray-900 mb-4 font-serif">
          Follow the Journey
        </h2>
        <p className="text-lg text-gray-500 mb-14 max-w-xl mx-auto">
          Get training tips, race-day motivation, and behind-the-scenes coaching content — follow PACED on social media.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          {/* Facebook */}
          <a
            href="https://www.facebook.com/share/17GLJU7ngf/"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-4 bg-white border border-gray-200 rounded-2xl px-8 py-6 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 w-full sm:w-72 cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1877F2]/10 group-hover:bg-[#1877F2]/20 transition-colors">
              <i className="ri-facebook-fill text-2xl text-[#1877F2]"></i>
            </div>
            <div className="text-left">
              <p className="text-xs text-gray-400 font-medium uppercase tracking-wide">Facebook</p>
              <p className="text-base font-bold text-gray-900 group-hover:text-[#1877F2] transition-colors">PACED Coaching</p>
            </div>
            <div className="ml-auto w-6 h-6 flex items-center justify-center text-gray-300 group-hover:text-[#1877F2] transition-colors">
              <i className="ri-arrow-right-line text-lg"></i>
            </div>
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/pacedcoaching/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-4 bg-white border border-gray-200 rounded-2xl px-8 py-6 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 w-full sm:w-72 cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#E1306C]/10 group-hover:bg-[#E1306C]/20 transition-colors">
              <i className="ri-instagram-line text-2xl text-[#E1306C]"></i>
            </div>
            <div className="text-left">
              <p className="text-xs text-gray-400 font-medium uppercase tracking-wide">Instagram</p>
              <p className="text-base font-bold text-gray-900 group-hover:text-[#E1306C] transition-colors">@PACEDCoaching</p>
            </div>
            <div className="ml-auto w-6 h-6 flex items-center justify-center text-gray-300 group-hover:text-[#E1306C] transition-colors">
              <i className="ri-arrow-right-line text-lg"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
